import type { RouteObject } from 'react-router';

import { lazyComponent } from '../lazy-component';
import { publicLoader } from './public-loader';
import { ssoCallbackLoader } from './sso-callback-loader';

export const publicRoutes: RouteObject = {
  loader: publicLoader,
  children: [
    // Client bucket — Azure B2C SSO (`client.okko.ua` after the domain split).
    {
      path: '/login',
      lazy: lazyComponent(() => import('@pages/client/login-page'), 'LoginPage'),
    },
    {
      path: '/login/sso/callback',
      loader: ssoCallbackLoader({ loginPath: '/login', errorPath: '/login/sso/error' }),
    },
    {
      path: '/login/sso/error',
      lazy: lazyComponent(() => import('@pages/client/sso-error-page'), 'SsoErrorPage'),
    },

    // Tenant bucket — Entra ID SSO (`tenant.okko.ua` after the domain split).
    // Prefixed in dev so both buckets are reachable from one build; after the
    // split each domain will serve its own set at the canonical `/login` URL.
    {
      path: '/tenant/login',
      lazy: lazyComponent(() => import('@pages/tenant/login-page'), 'LoginPage'),
    },
    {
      path: '/tenant/login/sso/callback',
      loader: ssoCallbackLoader({
        loginPath: '/tenant/login',
        errorPath: '/tenant/login/sso/error',
      }),
    },
    {
      path: '/tenant/login/sso/error',
      lazy: lazyComponent(() => import('@pages/tenant/sso-error-page'), 'SsoErrorPage'),
    },

    // Shared — same page for both buckets.
    {
      path: '/forgot-password',
      lazy: lazyComponent(
        () => import('@pages/shared/forgot-password'),
        'ForgotPassword',
      ),
    },
  ],
};
